module.exports = __webpack_public_path__ + "img/16logo.3528b233.svg";